import { SiteContentProvider } from "@/content/ContentContext.jsx";
import Navbar from "@/components/Navbar.jsx";
import Hero from "@/components/Hero.jsx";
import Marquee from "@/components/Marquee.jsx";
import About from "@/components/About.jsx";
import Facilities from "@/components/Facilities.jsx";
import Gallery from "@/components/Gallery.jsx";
import BookingForm from "@/components/BookingForm.jsx";
import LocationContact from "@/components/LocationContact.jsx";
import Footer from "@/components/Footer.jsx";
import WhatsAppFab from "@/components/WhatsAppFab.jsx";
import { Toaster } from "@/components/ui/sonner";

const Home = () => (
  <SiteContentProvider>
    <main className="bg-white font-sans text-ink">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Facilities />
      <Gallery />
      <BookingForm />
      <LocationContact />
      <Footer />
      <WhatsAppFab />
      <Toaster position="top-center" richColors />
    </main>
  </SiteContentProvider>
);

export default Home;
